
import React, { useContext, useState } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  Select,
  Form,
  Tag, Spin,
} from "antd";
import { useNavigate, NavLink } from "react-router-dom";

import { useEffect } from "react";
import {getFormattedDate, getTimeAgo, toTitleCase} from "../../utils/common";
import { fetchAllCampaigns } from "../../services/campaign.service";
import { GlobalContext } from "../../context/GlobalContext";
import { getStateNameById } from "./utils";
import { campaignPhase } from "../../constants/campaign.constant";
import { useTranslation } from "react-i18next";
import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { sn } from "make-plural";
import { CSVLink } from "react-csv";
import {roleValues} from "../../config/roles";

const { Option } = Select;
const columns = [
  {
    title: "SN",
    dataIndex: "sno",
    key: "sno",
    sorter: (a, b) => a.snoSort - b.snoSort,
    width: "10px",
  },
  {
    title: "District",
    dataIndex: "district",
    key: "district",
    sorter: (a, b) => a.districtSort.localeCompare(b.districtSort),
  },
  {
    title: "State",
    dataIndex: "state",
    key: "state",
    sorter: (a, b) => a.stateSort.localeCompare(b.stateSort),
  },
  {
    title: "Survivors Identified",
    dataIndex: "interviewsTaken",
    key: "interviewsTaken",
    sorter: (a, b) => a.interviewsTakenSort - b.interviewsTakenSort,
  },
  {
    title: "Phase",
    key: "phase",
    dataIndex: "phase",
    sorter: (a, b) => a.phaseSort.localeCompare(b.phaseSort),
  },
  {
    title: "DATE ADDED",
    key: "created",
    dataIndex: "created",
    sorter: (a, b) => new Date(a.createdSort) - new Date(b.createdSort),
  },
  {
    title: "Start Date",
    key: "startDate",
    dataIndex: "startDate",
    sorter: (a, b) => new Date(a.startDateSort) - new Date(b.startDateSort),
  },
  {
    title: "End Date",
    key: "endDate",
    dataIndex: "endDate",
    sorter: (a, b) => new Date(a.endDateSort) - new Date(b.endDateSort),
  },{
    title: "Created By",
    key: "createdBy",
    dataIndex: "createdBy",
    sorter: (a, b) => a.createdBySort.localeCompare(b.createdBySort),
  },
];

function Campaign() {
  const { i18n } = useLingui();
  const { setBreadCrumb, user } = useContext(GlobalContext);
  const [campaigns, setCampaigns] = useState([]);
  const navigate = useNavigate();
  const geoStates = JSON.parse(localStorage.getItem('GEO_STATES')) || [];
  const [formData, setFormData] = useState({ state: '', district: '', phase: ''});
  const [form] = Form.useForm();
  const [geoDistricts, setGeoDistricts] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setBreadCrumb([
      {
        title: 'Survivor Identification',
        link: '/location',
      },
    ]);
    loadDataFromServer();
  }, []);
  const loadDataFromServer = () => {
    const formValues = form.getFieldsValue();
    if (user.role === roleValues.dataProtectionOfficer || user.role === roleValues.projectCoordinator) {
      formValues.district = user.district;
    }
    fetchAllCampaigns(formValues)
        .then((response) => {
      let count = 0;
      const data = response.data.map((campaign) => {
        count++;
        return {
          key: campaign.uuid,
          sno: (
            <>
              <div>{count}</div>
            </>
          ),
          snoSort: count,
          created: (
            <>
              <div className="ant-employed">
                <span>{getTimeAgo(campaign.createdAt)}</span>
              </div>
            </>
          ),
          createdSort: campaign.createdAt,
          district: (
            <>
              <div>
                <span><NavLink to={`/location/detail/${campaign.uuid}`}>{campaign.district}</NavLink></span>
              </div>
            </>
          ),
          districtSort: campaign.district,
          state: (
            <>
              <div>
                <span>{getStateNameById(campaign.state)}</span>
              </div>
            </>
          ),
          stateSort: getStateNameById(campaign.state),
          interviewsTaken: (
            <>
              <div>
                <span>{campaign.interview.length}</span>
              </div>
            </>
          ),
          interviewsTakenSort: campaign.interview.length,
          phase: (
            <>
              <div className="ant-employed">
                <span>{toTitleCase(campaign.phase)}</span>
              </div>
            </>
          ),
          phaseSort: toTitleCase(campaign.phase),
          startDate: (
            <>
              <div className="ant-employed">
                <span>{getFormattedDate(campaign.startDate, 'MMMM DD, YYYY')}</span>
              </div>
            </>
          ),
          startDateSort: campaign.startDate,
          endDate: (
            <>
              <div className="ant-employed">
                <span>{getFormattedDate(campaign.endDate, 'MMMM DD, YYYY')}</span>
              </div>
            </>
          ),
          endDateSort: campaign.endDate,
          createdBy: (
              <>
                <div className="ant-employed">
                  <span>{campaign?.createdBy?.fullName || 'N/A'}</span>
                </div>
              </>
          ),
          createdBySort: campaign?.createdBy?.fullName,
        };
      });
      setCampaigns(data);
      // setCsvData(response.data.map(camp => {
      //   return {
      //     name:
      //   }
      // }));
    })
        .catch((error) => console.log(error))
        .finally(() => {setLoading(false)});
  }

  const changeState = (value) => {
    form.setFieldsValue({ district: '' });
    const districts = geoStates.find((state) => state?.details.id === value).districts;
    setGeoDistricts(districts);
    loadDataFromServer();
  };

  const handleClose = (val) => {
    form.setFieldsValue({ [val]: '' });
    loadDataFromServer();
  }
  return (
    <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`Districts (${campaigns.length})`}
              extra={
                  user.role === roleValues.admin &&
                <Button type="primary" className="tag-primary" onClick={() => navigate('/location/create')}>
                  New District
                </Button>
              }
            >
              <Form
              form={form}
              style={{ padding: "10px" }}
              layout="vertical"
              key={JSON.stringify(formData)}
              initialValues={formData}>
                <Row gutter={[24, 0]} style={{ padding: "10px" }}>
                  { roleValues.dataProtectionOfficer !== user.role && roleValues.projectCoordinator !== user.role &&
                  <Col xs={24} xl={6}>
                    <Form.Item
                      name="state"
                      label="State" >
                        <Select onChange={changeState}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }>
                          {geoStates.length > 0 && geoStates.map((item, index) => {
                            return (
                              <Option value={item?.details.id} key={index}>
                                {item?.details.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                  </Col>
                  }
                  { roleValues.dataProtectionOfficer !== user.role && roleValues.projectCoordinator !== user.role &&
                  <Col xs={24} xl={6}>
                    <Form.Item
                      name="district"
                      label="District" >
                        <Select onChange={loadDataFromServer}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }>
                          {geoDistricts.length > 0 && geoDistricts.map((item, index) => {
                            return (
                              <Option value={item.district} key={index}>
                                {item.district}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                  </Col>
                  }
                  <Col xs={24} xl={6}>
                    <Form.Item
                      name="phase"
                      label="Phase" >
                        <Select onChange={loadDataFromServer}>
                          {campaignPhase.map((phase, index) => {
                            return (
                              <Option value={phase.key} key={index}>
                                {phase.value}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[24, 0]}>
                  <Col>
                  { form.getFieldsValue() && form.getFieldsValue().state &&
                    <Tag closable style={{ margin: '5px' }} color="blue" onClose={() => handleClose('state')}>{getStateNameById(form.getFieldsValue()?.state)}</Tag>}
                  { form.getFieldsValue() && form.getFieldsValue().district &&
                    <Tag closable style={{ margin: '5px' }} color="blue" onClose={() => handleClose('district')}>{form.getFieldsValue()?.district}</Tag>}
                  { form.getFieldsValue() && form.getFieldsValue().phase &&
                    <Tag closable style={{ margin: '5px' }} color="blue" onClose={() => handleClose('phase')}>{form.getFieldsValue()?.phase}</Tag>}
                  </Col>
                </Row>
              </Form>
              <div className="table-responsive">
                <Spin spinning={loading}>
                  <Table
                    columns={columns}
                    dataSource={campaigns}
                    pagination={{
                      pageSize: 20,
                    }}
                    className="ant-border-space"
                  />
                </Spin>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
  );
}

export default Campaign;
